// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__26om2","app":"index_app__3sEGj"};